<script>
  import { External, M } from '../external';
  import CommentAdminService from './service';
  import AdminAuthorSettings from './Common/AdminAuthorSettings.svelte';
  import Moderation from './Moderation.svelte';
  import { onMount } from 'svelte';
  import { getVideoService } from '../Video/static';

  export let onComponentReady;

  const resourceDefinitions = [
    {
      id: 'blog_post',
      title: M.BLOG_POSTS_WIDGET_NAME,
      hasDetails: true,
      getDetails: (resourceData, resourceId) => {
        const post = resourceData.find((post) => '' + post.id === resourceId);
        if (post) {
          return {
            title: post.title,
            imageData: Array.isArray(post.featured?.data) ? post.featured.data[0] : post.featured?.data,
            imageDatabase: Array.isArray(post.featured?.dataBase) ? post.featured.dataBase[0] : post.featured?.dataBase
          };
        }
        return null;
      },
      fetchResourceData: async () => {
        const fetchPage = async (_page) => {
          return new Promise((resolve) => {
            External.Tools.makeWebsiteRequest({
              action: 'listBlogItems',
              data: {
                page: _page,
                type: 0
              },
              onOk: function (response) {
                resolve(response.data);
              }
            });
          });
        };

        const pagination = {
          page: 0,
          hasNextPage: true
        };
        let result = [];
        let items = [];
        while (pagination.hasNextPage && pagination.page < 100_000) {
          const response = await fetchPage(pagination.page);
          if (pagination.page + 1 >= response.pagesCount) {
            pagination.hasNextPage = false;
          }
          pagination.page += 1;

          items = [...items, ...response.items];

          result = [
            ...result,
            ...response.items.map((post) => {
              return { id: post.id, name: post.title };
            })
          ];
        }
        return { options: result, data: items };
      }
    },
    {
      id: 'standalone',
      title: M.WIDGET,
      hasDetails: false,
      fetchResourceData: async () => {
        const response = await CommentAdminService.getContexts('standalone');
        return {
          options: response.map((context) => {
            return {
              id: context.resourceId,
              name: context.name
            };
          }),
          data: response
        };
      },
      allowDelete: true
    },
    {
      id: 'wall',
      title: M.WALL_POSTS,
      hasDetails: false,
      fetchResourceData: async () => {
        const response = await CommentAdminService.getContexts('wall');
        return {
          options: response.map((context) => {
            return {
              id: context.resourceId,
              name: context.name
            };
          }),
          data: response
        };
      },
      allowDelete: true
    },
    {
      id: 'product_review_widget',
      title: M.REVIEWS,
      hasDetails: false,
      fetchResourceData: async () => {
        const response = await CommentAdminService.getContexts('product_review_widget');
        return {
          options: response.map((context) => {
            return {
              id: context.resourceId,
              name: context.name
            };
          }),
          data: response
        };
      },
      allowDelete: true
    },
    {
      id: 'video',
      title: M.VIDEO,
      hasDetails: true,
      getDetails: (resourceData, resourceId) => {
        const meta = resourceData.find((meta) => '' + meta.id === resourceId);
        if (meta) {
          return {
            title: meta.title,
            imageData: meta.thumbnailFileName,
            imageDatabase: meta.thumbnailFileBase
          };
        }
        return null;
      },
      fetchResourceData: async () => {
        const metas = await getVideoService('/meta');
        return {
          options: metas.map((meta) => {
            return {
              id: meta.id,
              name: meta.title
            };
          }),
          data: metas
        };
      }
    }
  ];

  const adminAuthor = {
    data: null,
    fetch: async () => {
      const response = await CommentAdminService.getAdminAuthor();
      adminAuthor.data = response;
    },
    update: async (name, extra) => {
      const updated = await CommentAdminService.updateAdminAuthor(name, extra);
      adminAuthor.data = updated;
    },
    showSettings: () => {
      let component;
      External.Tools.showWindow({
        isModal: true,
        title: M.ADMIN_AUTHOR_SETTINGS,
        width: 400,
        action: {
          onShow: (popup, ui) => {
            component = new AdminAuthorSettings({
              target: popup.getContentArea(),
              props: {
                name: adminAuthor.data?.name,
                extra: adminAuthor.data?.extra
              }
            });
            popup.bindComponent(component);
          },
          onHide: function () {
            if (component) {
              component.$destroy();
              component = null;
            }
          }
        },
        buttons: [
          External.Button(M.SAVE, External.Button.CLASS_MIDDLE_BLUE, async function (popup, context) {
            const author = await popup.component().getAuthor();
            adminAuthor.update(author.name, author.extra);
            popup.close();
          }),
          External.Button.MIDDLE_CANCEL
        ]
      });
    }
  };

  onMount(async () => {
    await adminAuthor.fetch();
  });
</script>

<!-- Comments Admin -->

<div class="account-settings store-settings">
  <div class="inner-wrapper members-table-wrapper">
    <div class="top-background-wrapper narrow-top-background">
      <div class="top-background">
        <h1 class="members-title f-left">{M.MODERATION}</h1>
        <div class="f-right flex-centered">
          <a
            on:click={adminAuthor.showSettings}
            class="f-left middle-button color-default rounded-effect ml-5 blue"
            style="height: 39px; line-height: 39px;">
            {M.SETTINGS}
          </a>
        </div>
      </div>
    </div>
    <div class="content-wrapper members-content-wrapper">
      <div class="padded-crm-wrapper">
        <Moderation {onComponentReady} {resourceDefinitions} />
      </div>
    </div>
  </div>
</div>
<!-- Comments Admin END -->
